var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipFileUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1893 5.51271L9.68927 2.01271C9.6026 1.91271 9.46927 1.85938 9.33594 1.85938H4.33594C3.7826 1.85938 3.33594 2.30604 3.33594 2.85938V14.8594C3.33594 15.4127 3.7826 15.8594 4.33594 15.8594H12.3359C12.8893 15.8594 13.3359 15.4127 13.3359 14.8594V5.85938C13.3359 5.72604 13.2826 5.59938 13.1893 5.51271ZM9.33594 3.05938L12.1359 5.85938H9.33594V3.05938ZM12.3359 14.8594H4.33594V2.85938H8.33594V5.85938C8.33594 6.41271 8.7826 6.85938 9.33594 6.85938H12.3359V14.8594Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipFileUpload);
export default __webpack_public_path__ + "static/media/ic-chip-file-upload.34b55389cf21a70a56ca814ca8262d32.svg";
export { ForwardRef as ReactComponent };